var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineOutpatientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5409 2.01306C13.5409 0.901276 12.6396 0 11.5278 0H8.47218C7.3604 0 6.45913 0.901277 6.45913 2.01306V6.45913H2.01306C0.901276 6.45913 3.08434e-07 7.3604 2.52951e-07 8.47218L1.00461e-07 11.5278C4.49779e-08 12.6396 0.901277 13.5409 2.01306 13.5409H6.45913V17.9869C6.45913 19.0987 7.3604 20 8.47218 20H11.5278C12.6396 20 13.5409 19.0987 13.5409 17.9869V13.5409H17.9869C19.0987 13.5409 20 12.6396 20 11.5278V8.47218C20 7.3604 19.0987 6.45913 17.9869 6.45913L13.5409 6.45913V2.01306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineOutpatientIcon);
export default __webpack_public_path__ + "static/media/timeline-outpatient-icon.05039b29ae45f6ebf45258cc863233ea.svg";
export { ForwardRef as ReactComponent };